var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app-bar",
    { attrs: { color: "primary", dark: "", flat: "", app: "" } },
    [
      _c("v-app-bar-nav-icon", {
        staticClass: "toggle-side-menu-button",
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.toggleLeftDrawer($event)
          }
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.leftTopMenu, function(item, index) {
        return [
          _c("top-menu-item", {
            key: "leftTopMenu-" + index,
            attrs: { item: item }
          })
        ]
      }),
      _vm._v(" "),
      _c("v-spacer"),
      _vm._v(" "),
      _vm._l(_vm.rightTopMenu, function(item, index) {
        return [
          _c("top-menu-item", {
            key: "rightTopMenu-" + index,
            attrs: { item: item }
          })
        ]
      }),
      _vm._v(" "),
      _c(
        "v-menu",
        {
          attrs: { bottom: "", left: "", "min-width": "200", "offset-y": "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function(ref) {
                var menu = ref.on
                return [
                  _c(
                    "v-btn",
                    _vm._g({ attrs: { icon: "" } }, Object.assign({}, menu)),
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [
                        _vm._v(
                          "\n                        $mdiShieldAccount\n                    "
                        )
                      ])
                    ],
                    1
                  )
                ]
              }
            }
          ])
        },
        [
          _vm._v(" "),
          _c(
            "v-list",
            { staticClass: "pa-0" },
            [
              _c(
                "v-list-item",
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c(
                        "v-list-item-title",
                        { staticClass: "text-center" },
                        [
                          typeof _vm.loggedInUser.first_name !== "undefined" &&
                          _vm.loggedInUser.first_name !== null &&
                          typeof _vm.loggedInUser.last_name !== "undefined" &&
                          _vm.loggedInUser.last_name !== null
                            ? [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.loggedInUser.first_name +
                                        " " +
                                        _vm.loggedInUser.last_name
                                    ) +
                                    "\n                            "
                                )
                              ]
                            : [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(_vm.loggedInUser.UserName) +
                                    "\n                            "
                                )
                              ]
                        ],
                        2
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-list-item",
                { on: { click: _vm.doLogout } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n                            Logout\n                        "
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }